import React from 'react';

import {assert} from 'Asserts';
import {
  CreateMixtureGroupExtras,
  MixtureGroupMetadata,
} from 'notebook/integrations/registry/MixtureGroupConstants';
import {isMixtureGroup} from 'notebook/integrations/registry/MixtureGroupConstants';
import makeCustomGroupButtonActionFunction from 'notebook/notes/groups/action-functions/makeCustomGroupButtonActionFunction';
import {getMixtureGroupAdapter} from 'notebook/notes/groups/NoteLinkedGroupAdapters';
import CreateRequestFromSamplesButton from 'requests/creation/CreateRequestFromSamplesButton';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

const createRequestForMixtureActionFunction = makeCustomGroupButtonActionFunction<
  MixtureGroupMetadata,
  CreateMixtureGroupExtras
>({
  renderToolbarButton: ({noteLinkedGroup, evaluatedTableMap}) => {
    assert(isMixtureGroup(noteLinkedGroup), 'Create request for mixture can only be used in a mixture group');
    const mixtureId = getMixtureGroupAdapter().getMixtureId(noteLinkedGroup, evaluatedTableMap);
    return (
      <CreateRequestFromSamplesButton
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className="u-mini-spacing-left"
        sampleInfos={mixtureId ? [{idForLookup: mixtureId}] : []}
        size={ButtonSize.MINI}
        noSamplesMessage="Register the mixture to create a request for it"
      />
    );
  },
  renderOverflowMenuItem: () => {
    throw new Error('Not implemented');
  },
});

export default createRequestForMixtureActionFunction;
